/* wl-entete.js — la queue du script de l'en-tete, sortie de la page le 26/08/2026 (phase 2b). Blocs autonomes : evenements de recherche, envoi d'images, tiroir mobile. L'adresse du moteur arrive par window.WLENT_MOTEUR (ilot inline de la section). */


  try {
  (function () {
    var URL_EVT = window.WLENT_MOTEUR + '/api/evt';
    var LANGUE = (window.Shopify && window.Shopify.locale) || 'fr';
    var file = [], minuteur = null;

    function tirage() {
      return Date.now().toString(36) + Math.random().toString(36).slice(2, 11);
    }
    function garde(magasin, cle) {
      var v = null;
      try { v = magasin.getItem(cle); } catch (e) {}
      if (!v) { v = tirage(); try { magasin.setItem(cle, v); } catch (e) {} }
      return v;
    }
    var VIS = garde(localStorage, '_wk_vid');     /* la meme cle que tracker.js */
    var SES = garde(sessionStorage, '_wk_sid');

    function cookie(nom) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + nom + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    }
    var SY = cookie('_shopify_y');

    function envoyer(fin) {
      if (!file.length) return;
      var charge = JSON.stringify({
        v: VIS, s: SES, l: LANGUE, y: SY || cookie('_shopify_y'),
        m: window.innerWidth <= 900 ? 1 : 0, evts: file
      });
      file = [];
      try {
        if (fin && navigator.sendBeacon) {
          navigator.sendBeacon(URL_EVT,
            new Blob([charge], { type: 'text/plain;charset=UTF-8' }));
        } else {
          fetch(URL_EVT, { method: 'POST', keepalive: true,
                           headers: { 'Content-Type': 'application/json' },
                           body: charge }).catch(function () {});
        }
      } catch (e) {}
    }

    function evt(type, cible, valeur, detail) {
      file.push({ t: type, c: cible, n: valeur, d: detail,
                  p: location.pathname.slice(0, 60) });
      if (file.length >= 20) { envoyer(false); return; }
      if (!minuteur) minuteur = setTimeout(function () {
        minuteur = null; envoyer(false);
      }, 5000);
    }
    window.wlEvt = evt;        /* le reste du fichier s'en sert */

    addEventListener('pagehide', function () { envoyer(true); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') envoyer(true);
    });

    var source = 'barre', cliqueRes = 0, resA = 0, resN = 0;

    function rang(el, sel) {
      var p = el.parentElement;
      if (!p) return null;
      var l = p.querySelectorAll(sel);
      for (var i = 0; i < l.length; i++) if (l[i] === el) return i + 1;
      return null;
    }
    function texte(el) {
      return el ? (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80) : '';
    }

    document.addEventListener('click', function (e) {
      var c;
      if ((c = e.target.closest('.wl-dp'))) {
        return evt('sug_clic', (c.getAttribute('href') || '').split('/').pop(),
                   rang(c, '.wl-dp'), 'tableau');
      }
      if ((c = e.target.closest('.wl-dc'))) {
        return evt('sug_clic', (c.getAttribute('href') || '').split('/').pop(),
                   rang(c, '.wl-dc'), 'collection');
      }
      if (e.target.closest('.wl-pied')) return evt('sug_clic', 'voir-tout', null, 'pied');

      if (e.target.closest('#wlAide')) return evt('bouton', 'trouver');
      if ((c = e.target.closest('[data-va]'))) {
        source = c.getAttribute('data-va');
        return evt('porte', source);
      }
      if (e.target.closest('#wlDepotCam')) return evt('photo', 'appareil');
      if (e.target.closest('#wlDepot')) return evt('photo', 'fichier');
      if ((c = e.target.closest('#wlGrille .wl-ch'))) {
        return evt('choix', c.getAttribute('data-id'), rang(c, '.wl-ch'));
      }
      if ((c = e.target.closest('#wlRes .wl-pc, #wlRes .wl-prod'))) {
        cliqueRes = 1;
        return evt('res_clic', source, rang(c, 'a'),
                   (c.getAttribute('href') || '').split('/').pop());
      }
      if ((c = e.target.closest('.wl-cr'))) {
        return evt('res_clic', (c.getAttribute('href') || '').split('/').pop(),
                   rang(c, '.wl-cr'), 'collection');
      }

      if ((c = e.target.closest('.wl-tir-sous2 a'))) {
        return evt('menu_clic', (c.getAttribute('href') || '').split('/').pop(),
                   null, 'sous-collection');
      }
      if ((c = e.target.closest('.wl-tir-sous > a, .wl-tir-sous > button'))) {
        return evt('menu_clic', texte(c.querySelector('.wl-tir-nom')) || texte(c),
                   null, 'famille');
      }
      if ((c = e.target.closest('.wl-nav-in .wl-s'))) {
        return evt('menu_clic', c.getAttribute('data-h'), null, 'sous-collection');
      }
      if ((c = e.target.closest('.wl-nav-in .wl-f'))) {
        return evt('menu_clic', c.getAttribute('data-h'), null, 'famille');
      }
      if ((c = e.target.closest('.wl-nav-in > .wl-rub > a, .wl-tir-n > a'))) {
        return evt('menu_clic', texte(c).replace(/[▾▼]/g, '').trim(),
                   null, 'rubrique');
      }

      if (e.target.closest('.wl-cote-g, #wlTirCorps a[href*="galerie"]')) {
        return evt('cote', 'galerie');
      }
      if (e.target.closest('.wl-cote-a, #wlTirCorps a[href*="avis"]')) {
        return evt('cote', 'avis');
      }
      if ((c = e.target.closest('.wl-aide-vol a, #wlTirCorps .wl-tir-s .wl-tir-sous2 a'))) {
        return evt('aide_clic', (c.getAttribute('href') || '').split('/').pop());
      }
      if (e.target.closest('.wl-aide-dec, #wlTirCorps .wl-tir-s > button')) {
        return evt('aide', 'ouvert');
      }
      if (e.target.closest('.wl-cpt, .wl-tir-cpt')) return evt('compte', 'clic');
      if (e.target.closest('.wl-pan-lien')) return evt('panier', 'clic');
      if (e.target.closest('#wlBurger')) return evt('menu', 'tiroir');
    }, true);

    function finResultats() {
      if (!resA) return;
      var ms = Date.now() - resA;
      resA = 0;
      evt('res_duree', source, Math.round(ms / 100) * 100,
          (cliqueRes ? 'clic' : 'sans clic') + ' · ' + resN + ' montres');
    }
    addEventListener('pagehide', finResultats);

    var pan = document.getElementById('wlPan');
    if (pan && window.MutationObserver) {
      var vu = {};
      new MutationObserver(function () {
        pan.querySelectorAll('[data-ecran]').forEach(function (el) {
          var n = el.getAttribute('data-ecran');
          if (el.hidden) {
            if (n === 'res') finResultats();
            vu[n] = 0;
            return;
          }
          if (vu[n]) return;
          vu[n] = 1;
          if (n === 'res') {
            resN = el.querySelectorAll('.wl-pc, .wl-prod').length;
            resA = Date.now(); cliqueRes = 0;
            evt('resultats', source, resN);
          } else {
            evt('porte', 'ecran-' + n);
          }
        });
      }).observe(pan, { attributes: true, subtree: true,
                        attributeFilter: ['hidden'] });
      new MutationObserver(function () {
        if (pan.hidden) finResultats();
      }).observe(pan, { attributes: true, attributeFilter: ['hidden'] });
    }

    var sug = document.getElementById('wlSug');
    if (sug && window.MutationObserver) {
      var ouvertSug = false, sugA = 0, sugQ = '', sugClic = 0, sugN = 0;
      document.addEventListener('click', function (e) {
        if (e.target.closest('#wlSug a, #wlSug .wl-pied')) sugClic = 1;
      }, true);
      new MutationObserver(function () {
        var o = sug.classList.contains('ouvert');
        if (o && !ouvertSug) {
          ouvertSug = true; sugA = Date.now(); sugClic = 0;
          var i = document.getElementById('wlInput');
          sugQ = i ? (i.value || '').slice(0, 60) : '';
          sugN = sug.querySelectorAll('.wl-dp').length;
        } else if (!o && ouvertSug) {
          ouvertSug = false;
          if (!sugClic && sugQ) {
            evt('sug_abandon', sugQ, Math.round((Date.now() - sugA) / 100) * 100,
                sugN + ' montres');
          }
        }
      }).observe(sug, { attributes: true, attributeFilter: ['class'] });
    }

    var ouvertA = 0, ouvertNom = '', attente = null;
    Array.prototype.forEach.call(
      document.querySelectorAll('.wl-nav-in > .wl-rub'), function (rub) {
        var lien = rub.querySelector(':scope > a');
        var nom = texte(lien).replace(/[▾▼]/g, '').trim();
        rub.addEventListener('mouseenter', function () {
          if (!rub.querySelector('.wl-vol')) return;
          clearTimeout(attente);
          attente = setTimeout(function () {
            ouvertA = Date.now(); ouvertNom = nom;
            evt('menu', nom, null, 'survol');
          }, 350);
        });
        rub.addEventListener('mouseleave', function () {
          clearTimeout(attente);
          if (!ouvertA || ouvertNom !== nom) return;
          var ms = Date.now() - ouvertA;
          ouvertA = 0;
          if (ms >= 500) evt('menu_duree', nom, Math.round(ms / 100) * 100);
        });
      });

    var tirA = 0, tirNom = '';
    function finTiroir() {
      if (!tirA) return;
      var ms = Date.now() - tirA; tirA = 0;
      if (ms >= 500) evt('menu_duree', tirNom, Math.round(ms / 100) * 100, 'tiroir');
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.wl-tir-n > button');
      if (b) {
        finTiroir();
        if (!b.classList.contains('ouvert')) {   /* il vient de s'ouvrir */
          tirA = Date.now(); tirNom = texte(b.querySelector('.wl-tir-nom')) || texte(b);
          evt('menu', tirNom, null, 'tiroir');
        }
        return;
      }
      if (e.target.closest('#wlTirX, #wlTirFond')) finTiroir();
    }, true);

    evt('page', 'vue', null, document.title.slice(0, 60));
  })();
  } catch (e) { /* le traceur ne doit jamais gener la page */ }

  try {
  (function () {
    var URL_IMG = window.WLENT_MOTEUR + '/api/image';
    var btn = document.getElementById('wlImgBtn');
    var pan = document.getElementById('wlImgPan');
    if (!btn || !pan) return;
    var bulle = document.getElementById('wlImgBulle');
    var depot = document.getElementById('wlImgDepot');
    var att = document.getElementById('wlImgAtt');
    var res = document.getElementById('wlImgRes');
    var exa = document.getElementById('wlImgExa');
    var exaC = document.getElementById('wlImgExaC');
    var sous = document.getElementById('wlImgSous');
    var liste = document.getElementById('wlImgListe');
    var rien = document.getElementById('wlImgRien');
    var err = document.getElementById('wlImgErr');
    var eCam = document.getElementById('wlImgCam');
    var eFic = document.getElementById('wlImgFic');
    var doux = window.matchMedia
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function suivre(t, c, n, d) {
      try { if (window.wlEvt) window.wlEvt(t, c, n, d); } catch (e) {}
    }
    function lireCookie(nom) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + nom + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    }
    function lireStock(magasin, cle) {
      try { return magasin.getItem(cle); } catch (e) { return null; }
    }

    var svg = btn.querySelector('.wl-img-cam');
    if (!doux && svg) {
      setInterval(function () {
        if (!pan.hidden) return;              /* panneau ouvert : on se tait */
        svg.classList.add('wl-img-vive');
        setTimeout(function () { svg.classList.remove('wl-img-vive'); }, 800);
      }, 3000);
    }

    btn.addEventListener('pointerenter', function () {
      if (lireStock(sessionStorage, 'wlImgBulleVue') || pan.hidden === false) return;
      try { sessionStorage.setItem('wlImgBulleVue', '1'); } catch (e) {}
      bulle.classList.add('wl-img-bulle-on');
      setTimeout(function () { bulle.classList.remove('wl-img-bulle-on'); }, 1800);
    });

    function montrer(quoi) {
      [depot, att, res, rien, err].forEach(function (b) {
        if (b) b.hidden = (b !== quoi);
      });
    }
    function ouvrir() {
      pan.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      bulle.classList.remove('wl-img-bulle-on');
      var sug = document.getElementById('wlSug');
      if (sug) sug.classList.remove('ouvert');
      suivre('img_porte', 'ouvre');
    }
    function fermer() {
      if (pan.hidden) return;
      pan.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      montrer(depot);
    }
    btn.addEventListener('click', function () {
      if (pan.hidden) ouvrir(); else fermer();
    });
    document.getElementById('wlImgFerme')
            .addEventListener('click', fermer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fermer();
    });
    document.addEventListener('pointerdown', function (e) {
      if (pan.hidden) return;
      if (!e.target.closest('#wlImgPan, #wlImgBtn')) fermer();
    });

    document.getElementById('wlImgPrendre')
            .addEventListener('click', function () { eCam.click(); });
    document.getElementById('wlImgChoisir')
            .addEventListener('click', function () { eFic.click(); });
    eCam.addEventListener('change', function () {
      if (eCam.files && eCam.files[0]) traiter(eCam.files[0], 'appareil');
      eCam.value = '';
    });
    eFic.addEventListener('change', function () {
      if (eFic.files && eFic.files[0]) traiter(eFic.files[0], 'fichier');
      eFic.value = '';
    });
    ['dragenter', 'dragover'].forEach(function (n) {
      depot.addEventListener(n, function (e) {
        e.preventDefault(); depot.classList.add('wl-img-drag');
      });
    });
    ['dragleave', 'drop'].forEach(function (n) {
      depot.addEventListener(n, function (e) {
        e.preventDefault(); depot.classList.remove('wl-img-drag');
      });
    });
    depot.addEventListener('drop', function (e) {
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) traiter(f, 'depot');
    });

    function traiter(fichier, source) {
      if (!fichier || fichier.type.indexOf('image/') !== 0) return;
      montrer(att);
      suivre('img_envoi', source);
      var lecteur = new FileReader();
      lecteur.onerror = function () { montrer(err); };
      lecteur.onload = function () {
        var im = new Image();
        im.onerror = function () { montrer(err); };
        im.onload = function () {
          var l = im.naturalWidth, h = im.naturalHeight;
          var k = Math.min(1, 512 / Math.max(l, h));
          var toile = document.createElement('canvas');
          toile.width = Math.max(1, Math.round(l * k));
          toile.height = Math.max(1, Math.round(h * k));
          toile.getContext('2d').drawImage(im, 0, 0, toile.width, toile.height);
          envoyer(toile.toDataURL('image/jpeg', 0.82));
        };
        im.src = lecteur.result;
      };
      lecteur.readAsDataURL(fichier);
    }

    function envoyer(donnees) {
      var charge = JSON.stringify({
        img: donnees,
        v: lireStock(localStorage, '_wk_vid'),
        s: lireStock(sessionStorage, '_wk_sid'),
        y: lireCookie('_shopify_y'),
        l: (window.Shopify && window.Shopify.locale) || 'fr',
        m: window.innerWidth <= 900 ? 1 : 0
      });
      fetch(URL_IMG, { method: 'POST',
                       headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
                       body: charge })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(traduireListe)
        .then(afficher)
        .catch(function () {
          montrer(err);
          suivre('img_resultat', 'erreur');
        });
    }

    /* Les titres dans la langue du client. Ce panneau est alimente
       directement par le service image, qui ne connait que le francais : sans
       ce detour, un Neerlandais voit ici du francais alors que la page de
       resultats juste apres est traduite. Si la traduction ne repond pas, on
       dessine quand meme — elle ne conditionne pas l'affichage. */
    function traduireListe(d) {
      var lg = (window.Shopify && window.Shopify.locale) || 'fr';
      if (lg === 'fr' || !d || !d.liste || !d.liste.length) return Promise.resolve(d);
      var ids = d.liste.map(function (x) { return x.id; }).filter(Boolean);
      if (!ids.length) return Promise.resolve(d);
      return fetch(URL_IMG.replace('/api/image', '/api/titres'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ langue: lg, ids: ids })
      }).then(function (r) { return r.ok ? r.json() : { titres: {} }; })
        .then(function (t) {
          var tab = t.titres || {};
          d.liste.forEach(function (x) { if (x.id && tab[x.id]) x.t = tab[x.id]; });
          if (d.exact && d.exact.id && tab[d.exact.id]) d.exact.t = tab[d.exact.id];
          return d;
        })
        .catch(function () { return d; });
    }

    function afficher(d) {
      if (!d || !d.ok) { montrer(err); suivre('img_resultat', 'erreur'); return; }
      if (d.rien || !d.liste || !d.liste.length) {
        montrer(rien);
        suivre('img_resultat', 'rien', 0);
        return;
      }
      var n = d.liste.length;
      if (d.exact) {
        exa.hidden = false;
        exaC.href = d.exact.u;
        exaC.setAttribute('data-wl-img-rang', '1');
        exaC.innerHTML = '';
        var ei = document.createElement('img');
        ei.src = d.exact.i + '?width=120';
        ei.alt = '';
        ei.loading = 'lazy';
        var et = document.createElement('span');
        et.textContent = d.exact.t;
        exaC.appendChild(ei); exaC.appendChild(et);
      } else {
        exa.hidden = true;
      }
      var reste = d.exact ? d.liste.slice(1) : d.liste;
      sous.hidden = !reste.length;
      liste.innerHTML = '';
      reste.slice(0, 6).forEach(function (x, i) {
        var a = document.createElement('a');
        a.className = 'wl-img-c';
        a.href = x.u;
        a.setAttribute('data-wl-img-rang', String(i + (d.exact ? 2 : 1)));
        var img = document.createElement('img');
        img.src = x.i + '?width=200';
        img.alt = '';
        img.loading = 'lazy';
        var t = document.createElement('span');
        t.textContent = x.t;
        a.appendChild(img); a.appendChild(t);
        liste.appendChild(a);
      });
      var pied = document.getElementById('wlImgPied');
      if (pied) {
        pied.hidden = !(d.ids && d.ids.length);
        pied.onclick = function () {
          try { sessionStorage.setItem('wlImgIds', JSON.stringify(d.ids)); }
          catch (e) {}
          suivre('img_clic', 'voir-tout', d.ids.length);
          var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          window.location.href = racine.replace(/\/$/, '') + '/pages/recherche-lab?img=1';
        };
      }
      montrer(res);
      suivre('img_resultat', d.exact ? 'exact' : 'similaires', n);
    }

    pan.addEventListener('click', function (e) {
      var a = e.target.closest('[data-wl-img-rang]');
      if (!a) return;
      var r = parseInt(a.getAttribute('data-wl-img-rang'), 10) || null;
      suivre('img_clic', (a.pathname || '').slice(0, 80), r);
    });
  })();
  } catch (e) { /* la porte photo ne doit jamais gener la page */ }

  (function () {
    var PAR_PAGE = 3, PAR_SESSION = 10;
    var doux = window.matchMedia
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (doux) return;                    /* on ne consomme meme pas le budget */
    var vues = 0;
    try { vues = parseInt(sessionStorage.getItem('wlEtoileVues'), 10) || 0; }
    catch (e) { vues = 0; }
    var n = Math.max(0, Math.min(PAR_PAGE, PAR_SESSION - vues));
    if (!n) return;                      /* le quota est epuise, rien ne bouge */
    document.documentElement.style.setProperty('--wl-sat-n', n);
    try { sessionStorage.setItem('wlEtoileVues', vues + n); } catch (e) {}
  })();

  (function () {
    var lien = document.querySelector('.wl-pan-lien');
    var img = document.getElementById('wlPanImg');
    if (!lien || !img) return;

    var URLS = [lien.getAttribute('data-pan0'), lien.getAttribute('data-pan1'),
                lien.getAttribute('data-pan2'), lien.getAttribute('data-pan3')];
    function precharger() {
      URLS.forEach(function (u) { if (u) { var p = new Image(); p.src = u; } });
    }
    if (window.requestIdleCallback) requestIdleCallback(precharger);
    else setTimeout(precharger, 1800);

    var dernier = null;
    function poser(n) {
      if (n === dernier) return;
      dernier = n;
      var u = URLS[Math.min(n, 3)];
      if (u && img.getAttribute('src') !== u) img.setAttribute('src', u);
      var roue = lien.querySelector('.wl-pan-roue');
      if (n > 0) {
        if (!roue) {
          roue = document.createElement('span');
          roue.className = 'wl-pan-roue';
          roue.id = 'wlPanRoue';
          lien.appendChild(roue);
        }
        var v = n > 99 ? 99 : n;
        roue.textContent = v;
        roue.classList.toggle('wl-deux', v > 9);
        roue.classList.remove('wl-maj');
        void roue.offsetWidth;            /* sinon l'animation ne repart pas */
        roue.classList.add('wl-maj');
      } else if (roue) {
        roue.remove();
      }
    }
    poser(parseInt(img.getAttribute('src').indexOf('panier-3') > -1 ? 3 :
          img.getAttribute('src').replace(/.*panier-(\d).*/, '$1'), 10) || 0);

    var enCours = false;
    function relire() {
      if (enCours) return;
      enCours = true;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d) poser(d.item_count || 0); })
        .catch(function () {})
        .then(function () { enCours = false; });
    }

    function estPanier(u) {
      return typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u);
    }
    var vraiFetch = window.fetch;
    if (vraiFetch) {
      window.fetch = function (e, o) {
        var u = typeof e === 'string' ? e : (e && e.url) || '';
        var p = vraiFetch.apply(this, arguments);
        if (estPanier(u)) p.then(function () { setTimeout(relire, 60); },
                                 function () {});
        return p;
      };
    }
    var vraiOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      if (estPanier(u)) this.addEventListener('load', function () {
        setTimeout(relire, 60);
      });
      return vraiOpen.apply(this, arguments);
    };
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (n) {
      document.addEventListener(n, relire);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) relire(); });
  })();

  (function () {
    var burger = document.getElementById('wlBurger');
    var tir = document.getElementById('wlTir');
    if (!burger || !tir) return;
    var corps = document.getElementById('wlTirCorps');
    var fond = document.getElementById('wlTirFond');
    var croix = document.getElementById('wlTirX');
    var bati = false, rendu = null;

    function fleche() {
      var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('viewBox', '0 0 24 24');
      s.setAttribute('fill', 'none');
      s.setAttribute('stroke', 'currentColor');
      s.setAttribute('stroke-width', '2');
      s.setAttribute('stroke-linecap', 'round');
      s.setAttribute('class', 'wl-tir-fl');
      s.innerHTML = '<path d="M6 9l6 6 6-6"/>';
      return s;
    }

    function replier(bouton, bloc) {
      bouton.addEventListener('click', function () {
        var ouvert = bloc.style.display !== 'none';
        bloc.style.display = ouvert ? 'none' : '';
        bouton.classList.toggle('ouvert', !ouvert);
        bouton.setAttribute('aria-expanded', String(!ouvert));
        if (!ouvert) servir(bloc);
      });
      bloc.style.display = 'none';
      bouton.setAttribute('aria-expanded', 'false');
    }

    /* Les vignettes en attente (data-hres) peuvent vivre a N'IMPORTE quel
       niveau du tiroir — y compris sur le bouton d'une famille, dont le
       parent n'est peut-etre jamais deplie. Des que la table arrive, on
       resout donc TOUT le tiroir d'un coup ; servir() garde la meme logique
       pour ce qui se batirait apres. */
    function resoudreHres(portee) {
      Array.prototype.forEach.call(
        portee.querySelectorAll('img[data-hres]'), function (im) {
          var u = window.wlVignette && wlVignette(im.getAttribute('data-hres'));
          im.removeAttribute('data-hres');
          if (u) { im.src = u; }
          else if (im.parentNode) { im.parentNode.parentNode.removeChild(im.parentNode); }
        });
    }

    function servir(bloc) {
      resoudreHres(bloc);
      Array.prototype.forEach.call(
        bloc.querySelectorAll('img[data-src]'), function (im) {
          im.src = im.getAttribute('data-src');
          im.removeAttribute('data-src');
        });
    }

    function ligneFam(cible, nom, h) {
      var u = wlVignette && wlVignette(h);
      /* La vignette peut ne pas etre connue ENCORE : la table arrive en
         differe. On pose quand meme le cadre, marque du handle, et
         servir() le resout a l'ouverture de la rubrique — la table est la
         depuis longtemps a ce moment. Si elle ne connait toujours pas le
         handle, le cadre est retire proprement. */
      if (u || h) {
        var cadre = document.createElement('span');
        cadre.className = 'wl-tir-vig';
        var im = document.createElement('img');
        if (u) { im.setAttribute('data-src', u); }
        else { im.setAttribute('data-hres', h); }
        im.alt = '';
        im.loading = 'lazy';
        im.decoding = 'async';
        /* IMAGE MORTE (fichier supprime quand une collection est refaite —
           cas « Autruche », 10/09/2026) : on retire le cadre, exactement
           comme pour une collection inconnue. Jamais d'icone cassee. */
        im.onerror = function () {
          var c = im.parentNode;
          if (c && c.parentNode) { c.parentNode.removeChild(c); }
        };
        cadre.appendChild(im);
        cible.appendChild(cadre);
      }
      var t = document.createElement('span');
      t.className = 'wl-tir-nom';
      t.textContent = nom;
      cible.appendChild(t);
    }

    function batir() {
      var nav = document.createElement('nav');
      nav.className = 'wl-tir-n';

      Array.prototype.forEach.call(
        document.querySelectorAll('.wl-nav-in > .wl-rub'), function (rub) {
          var lien = rub.querySelector(':scope > a');
          if (!lien) return;
          var vol = rub.querySelector('.wl-vol');
          var titre = (lien.textContent || '')
            .replace(/[▾▼↓]/g, '')
            .replace(/\s+/g, ' ').trim();

          if (!vol) {                                   /* rubrique simple */
            var a = document.createElement('a');
            a.href = lien.getAttribute('href');
            a.textContent = titre;
            nav.appendChild(a);
            return;
          }

          var b = document.createElement('button');
          b.type = 'button';
          b.appendChild(document.createTextNode(titre));
          var fams = vol.querySelectorAll('.wl-vol-fam .wl-f');
          b.appendChild(fleche());
          nav.appendChild(b);

          var sous = document.createElement('div');
          sous.className = 'wl-tir-sous';
          Array.prototype.forEach.call(fams, function (f, k) {
            var nom = (f.textContent || '').replace(/\s+/g, ' ').trim();
            var enf = vol.querySelector('.wl-vol-enf .wl-e[data-i="' + k + '"]');
            var scs = enf ? enf.querySelectorAll('.wl-liste .wl-s') : [];

            if (!scs.length) {          /* famille sans sous-collection */
              var af = document.createElement('a');
              af.href = f.getAttribute('href');
              ligneFam(af, nom, f.getAttribute('data-h'));
              sous.appendChild(af);
              return;
            }
            var bf = document.createElement('button');
            bf.type = 'button';
            ligneFam(bf, nom, f.getAttribute('data-h'));
            bf.appendChild(fleche());
            sous.appendChild(bf);

            var sous2 = document.createElement('div');
            sous2.className = 'wl-tir-sous2';
            var tout = enf.querySelector('.wl-tout');
            var at = document.createElement('a');
            at.className = 'wl-tir-tout';
            at.href = f.getAttribute('href');
            at.textContent = tout
              ? (tout.textContent || '').replace(/\s+/g, ' ').trim()
              : nom;
            sous2.appendChild(at);
            Array.prototype.forEach.call(scs, function (sc) {
              var a2 = document.createElement('a');
              a2.href = sc.getAttribute('href');
              a2.textContent = (sc.textContent || '').replace(/\s+/g, ' ').trim();
              sous2.appendChild(a2);
            });
            sous.appendChild(sous2);
            replier(bf, sous2);
          });
          nav.appendChild(sous);
          replier(b, sous);
        });
      corps.appendChild(nav);

      var bas = document.createElement('div');
      bas.className = 'wl-tir-s';
      Array.prototype.forEach.call(
        document.querySelectorAll('.wl-cote > a'), function (a) {
          bas.appendChild(a.cloneNode(true));
        });
      var aide = document.querySelector('.wl-aide-grp');
      if (aide) {
        var dec = aide.querySelector('.wl-aide-dec');
        var b3 = document.createElement('button');
        b3.type = 'button';
        var ic = document.createElement('span');
        ic.className = 'wl-tir-ic';
        var tel = dec.querySelector('.wl-tel');
        if (tel) ic.appendChild(tel.cloneNode(true));
        b3.appendChild(ic);
        b3.appendChild(document.createTextNode(
          (dec.querySelector('.wl-aide-mo') || {}).textContent || 'Aide'));
        b3.appendChild(fleche());
        bas.appendChild(b3);
        var sa = document.createElement('div');
        sa.className = 'wl-tir-sous2';
        Array.prototype.forEach.call(
          aide.querySelectorAll('.wl-aide-vol a'), function (a) {
            var x = document.createElement('a');
            x.href = a.getAttribute('href');
            x.textContent = (a.querySelector('b') || a).textContent;
            sa.appendChild(x);
          });
        bas.appendChild(sa);
        replier(b3, sa);
      }

      var cpt = document.querySelector('.wl-icos .wl-cpt');
      if (cpt) {
        var ac = document.createElement('a');
        ac.className = 'wl-tir-cpt';
        ac.href = cpt.getAttribute('href');
        var ic2 = document.createElement('span');
        ic2.className = 'wl-tir-ic';
        var sv = cpt.querySelector('svg');
        if (sv) ic2.appendChild(sv.cloneNode(true));
        ac.appendChild(ic2);
        ac.appendChild(document.createTextNode(
          cpt.getAttribute('aria-label') || 'Compte'));
        bas.appendChild(ac);
      }
      corps.appendChild(bas);

      var lang = document.querySelector('.wl-icos .wl-lang');
      if (lang) {
        var bl = document.createElement('div');
        bl.className = 'wl-tir-lang';
        var et = document.createElement('label');
        et.setAttribute('data-t', 'tirLangue');
        et.textContent = (window.T && T.tirLangue) || 'Langue';
        bl.appendChild(et);
        bl.appendChild(lang);
        corps.appendChild(bl);
      }
      bati = true;
    }

    function ouvrir() {
      /* la table des collections part maintenant ; a son arrivee, TOUTES
         les vignettes en attente du tiroir se resolvent d'un coup */
      if (window.wlTable) {
        wlTable().then(function () {
          var nav = document.querySelector('.wl-tir-n');
          if (nav) { resoudreHres(nav); }
        });
      }
      if (!bati) batir();
      rendu = document.activeElement;
      tir.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { tir.classList.add('ouvert'); });
      });
      wlBloquer();
      burger.setAttribute('aria-expanded', 'true');
      croix.focus();
    }

    function fermer() {
      tir.classList.remove('ouvert');
      wlDebloquer();
      burger.setAttribute('aria-expanded', 'false');
      setTimeout(function () { tir.hidden = true; }, 260);
      if (rendu && rendu.focus) rendu.focus();
    }

    burger.addEventListener('click', ouvrir);
    croix.addEventListener('click', fermer);
    fond.addEventListener('click', fermer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !tir.hidden) fermer();
    });
    window.addEventListener('resize', function () {
      if (innerWidth > 900 && !tir.hidden) fermer();
    });
  })();


